import React, { useContext } from 'react';

import { Context } from '@store/store';

import AddBookToShelfButton from './add-book-to-shelf-button';
import RemoveBookFromShelfButton from './remove-book-from-shelf-button';

const ToggleBookToShelf = ({ isMobile }) => {
  const [state] = useContext(Context);
  return state.isOnShelf ? (
    <RemoveBookFromShelfButton isMobile={isMobile} />
  ) : (
    <AddBookToShelfButton isMobile={isMobile} />
  );
};

export default ToggleBookToShelf;
